export const BOARD_COLUMN_WIDTH = { xs: '100%', md: 304 } as const;
